import Vue from "vue";
import App from "./App.vue";
import store from "./Store";
import "./assets/css/typography.css";
import router from "./router";
import "./components/common/Common";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
